import MuiCard, { CardProps as MuiCardProps } from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';

interface CustomCardProps extends MuiCardProps {
  square?: boolean;
}

export function Card<C extends React.ElementType = 'div'>(
  props: MuiCardProps<C, { component?: C }> & CustomCardProps
) {
  const { square, sx, children, elevation, variant = 'elevation' } = props;
  const defaultElevation = variant === 'elevation' ? 1 : 0;
  return (
    <MuiCard
      {...props}
      variant={variant}
      sx={[square && { borderRadius: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
      elevation={elevation !== undefined ? elevation : defaultElevation}
    >
      {children}
    </MuiCard>
  );
}

export { CardHeader, CardContent, CardActions, CardMedia, CardActionArea };
